/** Full locale de – edit as needed. */
export default {
  'nav.home': 'Start',
  'nav.seeDemo': 'Demo ansehen',
  'nav.howItWorks': 'So funktioniert es',
  'nav.pricing': 'Preise',
  'nav.aboutUs': 'Über uns',
  'nav.faqs': 'Häufige Fragen',
  'nav.contact': 'Kontakt',
  'nav.blog': 'Blog',
  'nav.logIn': 'Anmelden / Registrieren',
  'nav.getStarted': 'Loslegen',
  'brand.primeDocumentSign': 'Prime Document Sign',
  'hero.priceBanner': 'Bereits ab 2 $ pro Monat!',
  'hero.oneAgreement': 'Nur 1 Vereinbarung unterzeichnen? Nur 6 $ mit Premium-Features – kein Abo.',
  'hero.subscriptionsOnly': '( Nur Abonnements )',
  'hero.couponBannerText': 'Lebenslang 10 % Rabatt-Gutschein für unsere ersten 1000 Nutzer!',
  'hero.couponSubscribedOnly': '(nur für Abonnenten)',
  'hero.couponCode': '25OFFNEWUSERS1000',
  'hero.bannerEyebrow': 'E-Signatur-Plattform · Pläne ab 2 $/Monat',
  'hero.bannerHeadlinePrefix': 'Unterzeichnen Sie',
  'hero.bannerHeadlineMid': 'sofort',
  'hero.bannerHeadlineAccent': 'rechtssicher.',
  'hero.bannerCycleContracts': 'Verträge',
  'hero.bannerCycleNDAs': 'NDAs',
  'hero.bannerCycleProposals': 'Angebote',
  'hero.bannerCycleDocuments': 'Dokumente',
  'hero.bannerDesc':
    'Professionelle Vereinbarungen erstellen, zur E-Signatur senden und rechtsgültig unterzeichnete PDFs erhalten – in Minuten, auf jedem Gerät.',
  'hero.firebaseTopAria': 'Sicherheit und Hosting (Google Firebase und Google Cloud)',
  'hero.topTrustListAria': 'Sicherheit, Preise, Signatur, Erinnerungen und Support',
  'hero.accDataSafeTitle': 'Ihre Daten sind bei uns sicher',
  'hero.accDataSafe1':
    'Betrieben mit Google Firebase und Google Cloud – dieselbe Enterprise-Infrastruktur, der Millionen von Apps vertrauen',
  'hero.accDataSafe2':
    'Ihre Daten sind mit AES-256-Verschlüsselung in Ruhe mit Google-verwalteten Schlüsseln geschützt',
  'hero.accDataSafe3':
    'Sichere Authentifizierung und Datenverarbeitung nach führenden Google-Sicherheitsstandards',
  'hero.accDataSafe4': 'Wir verkaufen oder teilen Ihre Daten nicht – Ihre Privatsphäre wird respektiert',
  'hero.accDataSafe5Before': 'Volle Transparenz zur Speicherung und Nutzung Ihrer Daten (siehe unsere ',
  'hero.accDataSafe5After': ')',
  'hero.accPricingTitle': 'Einfache, transparente Preise – ohne versteckte Gebühren',
  'hero.accPricing1': 'Professionelle Vereinbarungen in Minuten erstellen',
  'hero.accPricing2': 'Pläne ab nur 2 $ pro Monat',
  'hero.accPricing3': 'Keine versteckten Gebühren',
  'hero.accPricing4': 'Keine Bindung – jederzeit kündbar',
  'hero.accPricing5': 'Ideal für Freelancer, Startups und KMU',
  'hero.accPricing6': 'Senden Sie Ihr erstes Dokument kostenlos',
  'hero.accSigningTitle': 'Schnell und einfach unterschreiben',
  'hero.accSigning1': 'Über 30 Vorlagen oder eigene Dateien nutzen',
  'hero.accSigning2': 'Signaturfelder in Sekunden hinzufügen und anpassen',
  'hero.accSigning3': 'Dokumente an mehrere Empfänger gleichzeitig senden',
  'hero.accSigning4': 'Vorlagen speichern und wiederverwenden',
  'hero.accSigning5': 'Empfänger brauchen kein Konto – sofort signieren',
  'hero.accSigning6': 'Live-Vorschau vor dem Versand',
  'hero.accRemindersTitle': 'Intelligente Erinnerungen und Nachverfolgung',
  'hero.accReminders1': 'Automatische Erinnerungen nach 1, 3 und 7 Tagen',
  'hero.accReminders2': 'Benachrichtigung bei Öffnung oder Unterschrift',
  'hero.accReminders3': 'Signaturprozess in Echtzeit verfolgen',
  'hero.accReminders4': 'Kein manuelles Nachfassen mehr',
  'hero.accAnywhereTitle': 'Überall arbeiten',
  'hero.accAnywhere1': 'Zugriff auf Desktop oder Smartphone',
  'hero.accAnywhere2': 'Senden und unterschreiben auf jedem Gerät',
  'hero.accAnywhere3': 'Flexibel – Büro oder unterwegs',
  'hero.accSupportTitle': 'Zuverlässiger Support',
  'hero.accSupport1': 'Dedizierter Kundenservice mit schnellen Antworten',
  'hero.accSupport2': 'Antwort in der Regel innerhalb von 24 Stunden',
  'hero.accSupport3': 'Laufende Updates auf Basis von Nutzerfeedback',
  'hero.firebaseTrustPrivacyLink': 'Datenschutzerklärung',
  'hero.firebaseTrustFineprintAfter':
    ' erklärt Aufbewahrung, Zugriff und Ihre Rechte. Wir verkaufen Ihre Daten nicht.',
  'hero.pill': 'Rechtlich bindende E-Signaturen in Sekunden versenden',
  'hero.headline': 'Das einfachste E-Signatur-Tool für Freelancer und kleine Teams',
  'hero.watchDemo': 'Demo ansehen',
  'hero.trustLocked': 'AES-256-Verschlüsselung',
  'hero.trustNoCard': 'Keine Karte nötig',
  'hero.trustReady': 'In 2 Min. einsatzbereit',
  'hero.landingShowMore': 'Mehr anzeigen',
  'hero.landingShowLess': 'Weniger anzeigen',
  'hero.tagline': 'Der einfachste Weg, Dokumente zu erstellen, zu unterschreiben und zu senden — ohne Bindung',
  'hero.ctaPrimary': 'Dokument erstellen / hochladen und zur Unterschrift senden',
  'hero.ctaTrialSignup': 'Jetzt testen mit 1 Monat kostenlosem Test',
  'hero.ctaFreeDocument': 'Jetzt ein kostenloses Dokument testen',
  'hero.ctaPrimaryNote': 'Keine Kreditkarte oder Zahlungsdaten erforderlich.',
  'hero.subscriptionTeaserBefore': 'Abonnements ab ',
  'hero.subscriptionTeaserAfter': ' pro Monat!',
  'hero.createAccountTrialHeadline': 'Jetzt registrieren und 1 Monat kostenlos testen',
  'hero.createAccountPromoCopy': 'Code kopieren',
  'hero.createAccountPromoCopied': 'Kopiert!',
  'hero.createAccountPromoCodeAria': 'Aktionscode: ein Monat gratis testen',
  'hero.createAccountNote': 'Beim Checkout eingeben, wenn du einen Plan wählst.',
  'hero.createAccountOfferLimit': '( Angebot nur für unsere ersten 1000 Nutzer gültig )',
  'hero.desc': 'Erstellen, senden und verfolgen Sie Vereinbarungen mit einem modernen Signiererlebnis.',
  'hero.getStartedFree': 'Kostenlos starten',
  'hero.tryWithoutAccountButton': 'Ohne Konto testen',
  'hero.logInSignUp': 'Anmelden / Registrieren',
  'hero.whyChooseUs': 'Warum wir?',
  'hero.stepsTitle': 'Erstellen, Unterschreiben, Empfangen',
  'hero.stepsSubtitle': 'Drei einfache Schritte, um Dokumente zu erstellen und in Minuten unterzeichnen zu lassen.',
  'hero.step1Create': 'Dokument hochladen oder erstellen',
  'hero.step2Sign': 'Zur Unterschrift senden',
  'hero.step3Receive': 'Sofort benachrichtigt werden nach der Unterzeichnung',
  'hero.benefit1': 'Einfach – Signaturlinks und E-Mails in Sekunden senden',
  'hero.benefit2': 'Bestehendes PDF hochladen oder Text extrahieren und im Rich-Text-Editor bearbeiten',
  'hero.benefit3': 'Text aus PDF extrahieren und bearbeiten',
  'hero.benefit4': 'Eigene Signaturfelder und Layouts in Sekunden erstellen',
  'hero.benefit5': 'An mehrere Empfänger gleichzeitig senden',
  'hero.benefit6': 'Kein Abo – einmalige Signatur nutzen',
  'hero.benefit7': 'Link kopieren und an jeden senden',
  'hero.benefit8': 'Vorlagen erstellen und speichern',
  'hero.benefit9': 'Alle E-Mail-Ereignisse einsehen',
  'hero.benefit10': 'Live-Vorschau und prüffähige PDFs',
  'hero.benefit11': 'Vorlagen mit flexibler Bearbeitung',
  'hero.benefit12': 'Empfänger müssen sich nicht registrieren',
  'hero.benefit13': 'Funktioniert auf allen Geräten',
  'how.simpleProcess': 'Einfacher Ablauf',
  'how.title': 'So funktioniert es',
  'how.subtitle': 'Erstellen, senden und unterschreiben in drei Schritten.',
  'how.step1Title': 'Vorlage erstellen',
  'how.step1Desc': 'PDF extrahieren und hochladen, Texteditor (von Grund auf oder einfügen und bearbeiten), Signaturfelder (Datum, Name, Bedingungen, Signaturblöcke), eigenes Layout. Als Vorlage speichern und wiederverwenden.',
  'how.step2Title': 'An Empfänger senden',
  'how.step2Desc': 'Dokumente per E-Mail mit sicheren, eindeutigen Signaturlinks senden. Mehrere Empfänger pro Versand, Links zum Teilen kopieren, Öffnen und Abschluss verfolgen.',
  'how.step3Title': 'Signierte PDFs erhalten',
  'how.step3Desc': 'Signierte PDFs mit Prüfprotokoll: Zeitstempel, E-Mail, Telefon, Einwilligung. Bestätigungs-E-Mail bei Abschluss.',
  'pricing.compareHeadline': 'Warum 19 $/Monat für E-Signaturen zahlen?',
  'pricing.comparePlatform': 'Plattform',
  'pricing.comparePrice': 'Preis',
  'pricing.compareUs': 'Prime Document Sign',
  'pricing.compareDocuSign': 'DocuSign',
  'pricing.compareDropboxSign': 'Dropbox Sign',
  'pricing.comparePandaDoc': 'PandaDoc',
  'pricing.comparePerMonth': '{price}/Monat',
  'pricing.compareBestValue': 'Bester Wert',
  'pricing.compareWhyPayLine1': 'Senden Sie in Sekunden rechtsgültige E-Signaturen',
  'pricing.compareWhyPayLine2': 'Mehr als ein Versand? Abonnements ab 2 $ pro Monat',
  'pricing.compareBenefitSingle': 'Einzeldokumente versenden',
  'pricing.compareBenefitNoContract': 'Keine teuren Verträge',
  'pricing.compareBenefitPayWhenNeed': 'Zahlen Sie nur bei Bedarf',
  'pricing.compareBenefitTemplates': 'Wählen Sie aus über 30 Vorlagen',
  'pricing.compareDisclaimer': 'Wettbewerberpreise basierend auf öffentlichen Starter-Plänen; können variieren.',
  'trust.secureLinks': 'Eindeutige, sichere Signaturlinks für jedes Dokument',
  'trust.auditTrail': 'Vollständiges Prüfprotokoll bei jeder Signatur (wer, wann, IP)',
  'trust.verifiablePdfs': 'Verifizierbare signierte PDFs zum Aufbewahren',
  'trust.footer': 'Vertraut von Freelancern und kleinen Unternehmen weltweit',
  'useCases.title': 'Perfekt für ( Vorlagen bereit )',
  'useCases.freelancers': 'Freelancer, die Verträge versenden',
  'useCases.agencies': 'Agenturen, die Vereinbarungen unterzeichnen',
  'useCases.landlords': 'Vermieter, die Mietverträge versenden',
  'useCases.startups': 'Startups, die NDAs unterzeichnen',
  'useCases.carBoat': 'Auto oder Boot mit rechtlichem Dokument verkaufen',
  'useCases.consultants': 'Berater und Selbstständige',
  'useCases.equipmentRental': 'Geräte mit formeller Vereinbarung vermieten',
  'useCases.contractors': 'Freie Auftragnehmer für Kundenaufträge',
  'useCases.website': 'Website- und Digitalprojekt-Vereinbarungen',
  'pricing.title': 'Preise',
  'pricing.billAnnually': 'Jährlich abrechnen',
  'pricing.billMonthly': 'Monatlich abrechnen',
  'pricing.getStarted': 'Loslegen',
  'pricing.mostPopular': 'BELIEBTESTE',
  'pricing.billedPerYear': '${amount}/Jahr',
  'pricing.perMonth': '/Monat',
  'pricing.tierBasic': 'Basis',
  'pricing.tierStandard': 'Standard',
  'pricing.tierPremium': 'Premium',
  'pricing.descBasic': 'Für gelegentliche Nutzung.',
  'pricing.descStandard': 'Für wachsende Teams.',
  'pricing.descPremium': 'Für Power-User mit erweiterten Anforderungen.',
  'about.label': 'Warum wir',
  'about.title': 'Über uns',
  'about.subtitle': 'Wir machen Signatur-Workflows einfach, schnell und sicher.',
  'about.speed': 'Geschwindigkeit',
  'about.builtForSpeed': 'Auf Geschwindigkeit ausgelegt',
  'about.builtForSpeedDesc': 'Moderne Oberfläche: Dokumente in Minuten erstellen und senden. Signieren von jedem Gerät.',
  'about.security': 'Sicherheit',
  'about.dataSecurity': 'Datensicherheit',
  'about.dataSecurityTitle': 'Gehostet auf Google Firebase & Google Cloud',
  'about.dataSecurityDesc': 'Ihre Kontodaten, Dokumente, Vorlagen und Signaturaktivität werden auf Google Firebase und Google Cloud verarbeitet – Plattformen für produktive Apps mit starker Authentifizierung und Speicherung. Der Datenverkehr nutzt durchgängig HTTPS (TLS); ruhende Daten werden mit von Google verwalteten Schlüsseln (einschließlich AES-256) verschlüsselt. Anmeldungen laufen über Firebase Authentication, und Firestore-Sicherheitsregeln stellen sicher, dass Lese- und Schreibvorgänge zu Ihrem Konto passen, damit Ihr Arbeitsbereich isoliert bleibt und nicht weltweit lesbar ist. Der Stack läuft im globalen Netzwerk von Google mit Monitoring, Patching und Verfügbarkeitspraktiken laut Google-Dokumentation. Wir verkaufen keine personenbezogenen Daten oder Dokumenteninhalte an Makler oder Werbetreibende. Zu Subprozessoren, Compliance und Ihren Rechten siehe unsere Datenschutzerklärung.',
  'about.dataSecurityPrivacyCta': 'Vollständige Datenschutzerklärung lesen →',
  'about.privacyPill': 'Datenschutz',
  'about.privacyFocused': 'Datenschutz im Fokus',
  'about.privacyFocusedDesc': 'Jeder Signaturlink ist eindeutig – Empfänger sehen nur, was Sie senden. Signierte PDFs enthalten eine klare Revisionsspur zum Ablegen: wer unterschrieben hat, wann und welche Einwilligung, damit Datenschutz und Nachweis zusammenpassen.',
  'about.teams': 'Einzelpersonen & Teams',
  'about.madeForTeams': 'Für Einzelpersonen und Teams',
  'about.madeForTeamsDesc': 'Vorlagen für alle: Texte, Überschriften, Listen, Signaturfelder, Datum, Name, benutzerdefinierte Felder. Vorlagen speichern und wiederverwenden.',
  'about.sectionHeadlineBefore': 'Gebaut für ',
  'about.sectionHeadlineAccent': 'Vertrauen & Geschwindigkeit',
  'about.firebaseVisualBadge': 'Google Firebase · Google Cloud',
  'faq.title': 'Häufige Fragen',
  'faq.searchHint': 'Suchen Sie nach Stichwörtern, um schnell FAQs zu finden',
  'faq.searchPlaceholder': 'z.B. PDF, Vorlage, Signatur...',
  'faq.noResults': 'Keine FAQs entsprechen Ihrer Suche. Versuchen Sie andere Stichwörter.',
  'faq.more': 'Mehr',
  'faq.less': 'Weniger',
  'faq.eyebrow': 'Noch Fragen?',
  'faq.titleBefore': 'Häufig gestellte ',
  'faq.titleAccent': 'Fragen',
  'faq.subtitleLead': 'Alles Wichtige zu Prime Document Sign. Keine Antwort gefunden? ',
  'faq.subtitleLink': 'Kontaktieren Sie uns.',
  'faq.clearSearchAria': 'Suche löschen',
  'faq.subscriptionsWorkQ': 'Wie funktionieren Abos?',
  'faq.subscriptionsWorkA': 'Premium-Plan (${{monthly}} $/Monat oder ${{annual}} $/Jahr). Einmalzahlung pro Versand möglich. Abos über Stripe. Verwalten unter Mein Konto → Mein Abo.',
  'faq.upgradePlanQ': 'Plan upgraden?',
  'faq.upgradePlanA': 'Mein Konto → Mein Abo, höheren Tarif wählen und bestätigen. Upgrade meist sofort.',
  'faq.downgradePlanQ': 'Plan downgraden?',
  'faq.downgradePlanA': 'Mein Konto → Mein Abo, niedrigeren Tarif wählen. Änderung zum nächsten Abrechnungszeitraum.',
  'faq.cancelPlanQ': 'Abo kündigen?',
  'faq.cancelPlanA': 'Mein Konto → Mein Abo, über Stripe kündigen oder Support kontaktieren. Kündigung zum Periodenende.',
  'faq.oneTimeOptionQ': 'Was ist die Einmalzahlung pro Versand?',
  'faq.oneTimeOptionA': 'Gelegentlich senden: ${{oneTimePrice}} $ pro Versand statt Abo. Premium-Funktionen für diesen Versand. Bei Anmeldung oder unter Mein Abo wählen.',
  'faq.emailLimitQ': 'Was passiert bei monatlichem E-Mail-Limit?',
  'faq.emailLimitA': 'Basis: 5 E-Mails/Monat, Standard: 50, Premium: 150. Limit wird monatlich zurückgesetzt. Bei Erreichen: Aufstocken oder upgraden.',
  'faq.yearlyBillingQ': 'Jährliche Abrechnung?',
  'faq.yearlyBillingA': 'Ja. Premium: ${{monthly}} $/Monat oder ${{annual}} $/Jahr. Jährlich spart bis {{discountPercent}}%. In Mein Abo wechseln.',
  'faq.multipleRecipientsQ': 'Mehrere Empfänger?',
  'faq.multipleRecipientsA': 'Ja. Basis: bis 5, Standard und Premium: bis 10. E-Mails kommagetrennt. Jeder erhält eigenen Link. Kein Konto nötig.',
  'faq.reuseTemplatesQ': 'Vorlagen wiederverwenden?',
  'faq.reuseTemplatesA': 'Basis: 3, Standard: 10, Premium: 25 Vorlagen. Vorlagenverlauf (Mein Konto) lädt gespeicherte Vorlagen.',
  'faq.recipientAccountQ': 'Braucht der Empfänger ein Konto?',
  'faq.recipientAccountA': 'Nein. E-Mail mit Link, direkt vom Gerät unterschreiben. Kein Konto. Desktop, Tablet, Handy.',
  'faq.confirmationEmailQ': 'Bestätigungs-E-Mail?',
  'faq.confirmationEmailA': 'Ja. Bei Abschluss E-Mail mit signiertem PDF. Jedes PDF mit Prüfprotokoll.',
  'faq.previewPdfQ': 'PDF vor dem Senden anzeigen?',
  'faq.previewPdfA': 'Ja. Button „PDF-Vorschau“ für exaktes Layout. Dann senden oder Link kopieren.',
  'faq.editAgreementQ': 'Vertragstext bearbeiten?',
  'faq.editAgreementA': 'Ja. Texteditor für Überschriften, Listen, Fett, Kursiv, Unterstreichen. PDF hochladen zum Extrahieren oder Anzeigen.',
  'faq.signatureRequiredQ': 'Signatur Pflicht?',
  'faq.signatureRequiredA': 'Ja. Empfänger müssen Datum, Name, Bedingungen, Signatur ausfüllen. Rechtliche Anforderungen.',
  'faq.attachmentsQ': 'Wie viele Anhänge?',
  'faq.attachmentsA': 'Basis: keine. Standard: 3 (8 MB gesamt). Premium: 10 (8 MB gesamt). Mit Signaturlink gesendet.',
  'faq.emailActivityQ': 'E-Mail-Aktivität (Premium)?',
  'faq.emailActivityA': 'Premium: E-Mail-Aktivität unter Mein Konto. Welche Dokumente, wann, an wen. Für Compliance.',
  'faq.emailRemindersQ': 'Wie funktionieren E-Mail-Erinnerungen?',
  'faq.emailRemindersA': 'Im Dokumenten-Editor (Schritt 4, Zusatzfunktionen) können Sie pro Versand 1-, 3- und/oder 7-Tage-Erinnerungen aktivieren. Nach der ersten Signatur-E-Mail senden wir nur dann eine Erinnerung, wenn der Empfänger das Dokument noch nicht abgeschlossen hat. Erinnerungen enden automatisch nach der Unterschrift. Erinnerungs-E-Mails erscheinen in der E-Mail-Aktivität mit Zeitstempel und zählen nicht gegen Ihr monatliches Sendelimit.',
  'faq.defaultSenderQ': 'Standard-Absender-E-Mail?',
  'faq.defaultSenderA': 'Mein Konto → Kontodaten, E-Mail eintragen und speichern. Wird beim Senden vorausgefüllt.',
  'faq.mobileSignQ': 'Auf dem Handy unterschreiben?',
  'faq.mobileSignA': 'Ja. Responsive. Link auf Smartphone/Tablet öffnen, mit Finger oder Stylus unterschreiben.',
  'faq.getHelpQ': 'Hilfe?',
  'faq.getHelpA': 'Support unter Mein Konto oder Kontaktformular. Wir antworten schnell.',
  'faq.dataSecureQ': 'Sind meine Daten sicher?',
  'faq.dataSecureA': 'Ja. Branchenübliche Sicherheit. Dokumente sicher übertragen und gespeichert.',
  'faq.fileFormatsQ': 'Welche Dateiformate?',
  'faq.fileFormatsA': 'Dokumente im Texteditor. Abgeschlossene als PDF.',
  'faq.deleteTemplateQ': 'Vorlage gelöscht?',
  'faq.deleteTemplateA': 'Gelöschte Vorlagen sind dauerhaft weg. Vor dem Löschen prüfen. Neue Vorlage jederzeit aus aktuellem Dokument.',
  'faq.ownLogoQ': 'Eigenes Logo?',
  'faq.ownLogoA': 'Ja, bei Standard und Premium. Logo (bis 20 KB) hochladen und Position wählen. Basis nicht.',
  'faq.uploadPdfQ': 'Wie lade ich ein PDF hoch?',
  'faq.uploadPdfA': 'Im Dokumenten-Editor: Option PDF hochladen (Standard und Premium). Ihr PDF wird über oder neben dem Vertragstext angezeigt. Empfänger sehen das vollständige Dokument beim Signieren.',
  'faq.extractPdfQ': 'Was ist PDF-Extraktion und wie funktioniert sie?',
  'faq.extractPdfA': 'PDF-Extraktion (Standard und Premium) holt Text aus einem bestehenden PDF in den Editor. PDF hochladen, „Text extrahieren“ wählen – der Inhalt wird kopiert. Dann bearbeiten und Signaturfelder hinzufügen.',
  'faq.richTextEditorQ': 'Was kann ich mit dem Rich-Text-Editor machen?',
  'faq.richTextEditorA': 'Der Editor ermöglicht Überschriften, Fett, Kursiv, Listen und Schriftgrößen. Signaturblöcke darunter hinzufügen. Alles per Klick, ohne Code.',
  'faq.previewWhenQ': 'Wann sollte ich vor dem Senden eine Vorschau machen?',
  'faq.previewWhenA': 'Immer PDF-Vorschau vor dem Senden nutzen. Zeigt das exakte Layout: Vertragstext, Signaturblöcke, Datum, Name. Formatierung prüfen, dann senden.',
  'faq.documentLifetimeQ': 'Wie lange sind Signaturlinks gültig? Kann ich eine Verlängerung anfragen?',
  'faq.documentLifetimeA': 'Links bleiben etwa 30 Tage aktiv. PDF vor Ablauf herunterladen und speichern. Bei abgelaufenem Link den Absender um eine neue E-Mail mit frischem Link bitten.',
  'faq.editLayoutQ': 'Wie bearbeite ich das Signatur-Layout?',
  'faq.editLayoutA': '„Layout bearbeiten“ in der Signatur-Sektion nutzen. Felder per Drag & Drop anordnen: Datum, Name, Bedingungen, Signaturen, benutzerdefinierte Felder. Spacer hinzufügen, Spaltenanzahl wählen.',
  'faq.customFieldsQ': 'Wie füge ich benutzerdefinierte Felder hinzu (Text, Datum, Checkbox usw.)?',
  'faq.customFieldsA': '„Benutzerdefiniertes Feld hinzufügen“ klicken. Label und Typ wählen: Text, Zahl, Datum, Zeit, Auswahlliste, Checkbox oder Signatur. Bis zu 10 Felder pro Dokument. Angeben, welche Signatare jedes Feld sehen, dann Layout bearbeiten.',
  'faq.multipleSignaturesQ': 'Kann ich 2 oder mehr Signaturen (mehrere Signatare) hinzufügen?',
  'faq.multipleSignaturesA': 'Ja. In der Empfänger-Sektion zweiten Signatar hinzufügen. Jeder erhält eigenen Link und Signaturblock. Basis: bis 5, Standard/Premium: bis 10 Empfänger pro Versand.',
  'faq.documentBuilderTipsQ': 'Was kann ich im Dokumenten-Editor machen?',
  'faq.documentBuilderTipsA': 'Verträge erstellen, PDFs hochladen oder extrahieren, Signaturblöcke, benutzerdefinierte Felder und Anhänge hinzufügen. Layout bearbeiten, Vorlagen speichern, PDF-Vorschau. Änderungen werden automatisch gespeichert.',
  'faq.clearEverythingQ': 'Was macht „Alles löschen“?',
  'faq.clearEverythingA': '„Alles löschen“ setzt den Editor zurück: Text, Signaturblöcke, benutzerdefinierte Felder und Anhänge. Für einen Neustart. Gespeicherte Vorlagen bleiben unberührt.',
  'faq.forgotPasswordQ': 'Ich habe mein Passwort vergessen. Wie reagiere ich?',
  'faq.forgotPasswordA': 'Auf dem Login-Bildschirm: Passwort vergessen? E-Mail eingeben. Link in der Inbox (und Spam) prüfen. Link setzt neues Passwort. Bei Ablauf: neuen Link anfordern. Mit neuem Passwort einloggen.',
  'faq.saveTemplateQ': 'Wie speichere ich ein Dokument als Vorlage?',
  'faq.saveTemplateA': 'Dokument erstellen, dann Vorlage speichern klicken. Namen vergeben und Als neu speichern. Erscheint in Vorlagenverlauf (Mein Konto). Zum Aktualisieren: Vorlage laden, ändern, Vorlage speichern → Vorlage aktualisieren.',
  'faq.loadTemplateQ': 'Wie lade ich eine Vorlage aus dem Verlauf?',
  'faq.loadTemplateA': 'Mein Konto → Vorlagenverlauf. Gewünschte Vorlage anklicken. Öffnet im Editor mit vollem Inhalt und Layout. Bei Bedarf bearbeiten, Empfänger hinzufügen, senden.',
  'faq.templateLimitsQ': 'Wie viele Vorlagen kann ich speichern?',
  'faq.templateLimitsA': 'Basis: 3, Standard: 10, Premium: 25 Vorlagen. Jede speichert Text, Formatierung, Signaturblöcke und Layout. Bei Limit: alte löschen oder Plan upgraden.',
  'faq.recipientNoEmailQ': 'Empfänger hat Signatur-E-Mail nicht erhalten?',
  'faq.recipientNoEmailA': 'Spam prüfen lassen. Link kopieren und manuell teilen (SMS, Slack, etc.). Oder Dokument erneut an dieselbe E-Mail senden—neuer Link wird erstellt.',
  'faq.editAfterSendQ': 'Kann ich ein Dokument nach dem Senden bearbeiten?',
  'faq.editAfterSendA': 'Nein. Nach dem Senden ist der Inhalt gesperrt. Für Änderungen: neues Dokument mit den Änderungen erstellen und erneut senden. Ungesendete Entwürfe können frei bearbeitet werden.',
  'faq.changeAccountQ': 'Wie ändere ich E-Mail oder Passwort?',
  'faq.changeAccountA': 'Mein Konto → Kontodaten. E-Mail oder Passwort aktualisieren. Für Passwort: aktuelles und neues eingeben. Bei Vergessen: Passwort vergessen? auf dem Login-Bildschirm nutzen.',
  'faq.browserSupportQ': 'Welche Browser und Geräte werden unterstützt?',
  'faq.browserSupportA': 'Chrome, Firefox, Safari, Edge (Desktop und Mobil). Responsive Signatur—Smartphones und Tablets. Aktuelle Browser-Versionen empfohlen. Keine App nötig.',
  'faq.copyLinkQ': 'Wie kopiere ich einen Link zum Teilen statt per E-Mail?',
  'faq.copyLinkA': 'Nach Dokumenterstellung: Link kopieren klicken. URL in Zwischenablage. In Nachricht, E-Mail oder Slack einfügen. Empfänger kann ohne E-Mail von uns signieren.',
  'faq.resendDocumentQ': 'Kann ich ein Dokument erneut senden, wenn noch nicht signiert?',
  'faq.resendDocumentA': 'Ja. Gleiches Dokument erneut an dieselbe oder andere E-Mail senden. Jeder Versand erstellt neuen Link. Bei abgelaufenem Link: erneuter Versand gibt frischen Link. E-Mail-Aktivität (Premium) zeigt Versandstatus.',
  'testimonials.eyebrow': 'ERFAHRUNGEN',
  'testimonials.title': 'Was unsere Kunden sagen.',
  'testimonials.quote1': 'Sehr günstig. Bester Preis und einfach zu bedienen.',
  'testimonials.quote2': 'Vertrag von ChatGPT eingefügt, in Minuten bearbeitet und zur Signatur gesendet. Unter 10 Minuten.',
  'testimonials.quote3': 'Alles vom Handy: Dokument erstellt, Signaturfelder gesetzt, unterwegs gesendet.',
  'testimonials.quote4': 'Einfach und faire Preise. Keine versteckten Kosten. Team nutzt es für Verträge und NDAs.',
  'testimonials.quote5': 'Vertragstext eingefügt, Signaturblöcke gesetzt, gesendet. Am gleichen Tag unterschrieben.',
  'testimonials.quote6': 'Am Laptop und Handy. Läuft auf beiden. Bester E-Signatur-Preis.',
  'testimonials.prev': 'Zurück',
  'testimonials.next': 'Weiter',
  'contact.title': 'Kontakt',
  'contact.subtitle': 'Haben Sie Fragen? Wir freuen uns über Ihre Nachricht.',
  'contact.eyebrow': 'Kontakt aufnehmen',
  'contact.headlineBefore': 'Lassen Sie uns ',
  'contact.headlineAccent': 'sprechen',
  'contact.responseTimeLabel': 'Antwortzeit',
  'contact.responseTimeValue': 'Innerhalb von 24 Stunden',
  'contact.secureLabel': 'Sicher & privat',
  'contact.secureValue': 'AES-256-Verschlüsselung',
  'contact.trustNoSpam': 'Kein Spam, versprochen',
  'contact.trustHumanSupport': 'Echter menschlicher Support',
  'contact.firstName': 'Vorname',
  'contact.lastName': 'Nachname',
  'contact.email': 'E-Mail',
  'contact.message': 'Nachricht',
  'contact.sendMessage': 'Nachricht senden',
  'contact.required': '*',
  'contact.placeholderFirst': 'Vorname eingeben',
  'contact.placeholderLast': 'Nachname eingeben',
  'contact.placeholderEmail': 'E-Mail eingeben',
  'contact.placeholderMessage': 'Wie können wir helfen?',
  'contact.attachments': 'Anhänge',
  'contact.attachmentsHint': 'Bis 5 Dateien, 2 MB gesamt',
  'contact.addFiles': '+ Dateien',
  'contact.addAttachmentsAria': 'Anhänge hinzufügen',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.backToLogIn': 'Zurück zur Anmeldung',
  'auth.sendResetLink': 'Link zum Zurücksetzen senden',
  'auth.checkEmailReset': 'Link in Ihrer E-Mail prüfen.',
  'auth.emailLabel': 'E-Mail',
  'auth.passwordLabel': 'Passwort',
  'auth.firstNameLabel': 'Vorname',
  'auth.lastNameLabel': 'Nachname',
  'auth.enterEmail': 'E-Mail eingeben.',
  'auth.enterEmailPassword': 'E-Mail und Passwort eingeben.',
  'auth.passwordMinLength': 'Mindestens 8 Zeichen.',
  'auth.passwordSpecial': 'Mindestens ein Sonderzeichen.',
  'auth.passwordsNoMatch': 'Passwörter stimmen nicht überein.',
  'auth.signInWithGoogle': 'Mit Google anmelden',
  'auth.or': 'oder',
  'auth.logInFailed': 'Anmeldung fehlgeschlagen.',
  'auth.signUpFailed': 'Registrierung fehlgeschlagen.',
  'auth.emailAlreadyInUse': 'Diese E-Mail-Adresse wird bereits verwendet.',
  'connectionError.message': 'Verbindungsproblem. Bitte prüfen Sie Ihre Internetverbindung und laden Sie die Seite neu.',
  'connectionError.refresh': 'Seite neu laden',
  'connectionError.tooManyRequests': 'Zu viele Versuche. Bitte versuchen Sie es später erneut.',
  'auth.emailPlaceholder': 'max@beispiel.de',
  'auth.passwordPlaceholder': 'Passwort eingeben',
  'auth.firstNamePlaceholder': 'Max',
  'auth.lastNamePlaceholder': 'Mustermann',
  'auth.manageSubscription': 'Abo verwalten',
  'auth.subscribe': 'Abonnieren',
  'auth.signUpForSubscription': 'Für Abo registrieren',
  'auth.currentPlan': 'AKTUELLER PLAN',
  'auth.updatePlanHint': 'In Stripe upgraden für mehr monatliche Credits.',
  'auth.updatePlanStripe': 'Plan, Zahlung oder Kündigung im Stripe-Portal.',
  'auth.subscribeToPlan': 'Plan wählen zum Start.',
  'auth.topUpCredits': 'Credits kaufen ({{label}}: ${{price}})',
  'pricing.featureRecipients5': 'Bis 5 Empfänger pro Versand',
  'pricing.featureRecipients10': 'Bis 10 Empfänger pro Versand',
  'pricing.featureEmails5': 'Max. 5 E-Mails/Monat',
  'pricing.featureEmails50': 'Max. 50 E-Mails/Monat',
  'pricing.featureEmails150': 'Max. 150 E-Mails/Monat',
  'pricing.featureTemplates3': '3 Vorlagen',
  'pricing.featureTemplates10': '10 Vorlagen',
  'pricing.featureTemplates25': '25 Vorlagen',
  'pricing.featureChars3k': '3.000 Zeichen',
  'pricing.featureChars20k': '20.000 Zeichen',
  'pricing.featureChars30k': '30.000 Zeichen',
  'pricing.featureAttachmentsNone': 'Keine Anhänge',
  'pricing.featureAttachments3': '3 Anhänge (8 MB)',
  'pricing.featureAttachments10': '10 Anhänge (8 MB)',
  'pricing.featurePdfUpload': 'PDF-Upload',
  'pricing.featureAuditTrail': 'Prüfprotokoll',
  'pricing.featurePdfExtract': 'PDF-Text extrahieren und bearbeiten',
  'pricing.featureCustomFields': 'Eigene Felder und Layout',
  'pricing.featureCopyLink': 'Link zum Signieren kopieren',
  'pricing.featureLogo': 'Logo hochladen',
  'pricing.featureVerification': 'Empfänger-Verifizierung',
  'app.createYourDocument': 'Dokument erstellen',
  'app.backToApp': 'Zurück zur App',
  'app.backToMainSite': 'Zurück zur Website',
  'app.backShort': 'Zurück',
  'app.myAccount': 'Mein Konto',
  'app.saveTemplate': 'Vorlage speichern',
  'app.templatesUsed': 'Genutzte Vorlagen',
  'app.templatesUsedSaved': '{{count}} Vorlagen gespeichert',
  'app.startFromTemplate': 'Aus Vorlage starten',
  'app.startFromTemplateHint': 'Wählen Sie eine Vorlage zum Ausfüllen des Dokuments. Sie können sie nach der Auswahl bearbeiten.',
  'app.signedInAs': 'Angemeldet als',
  'app.sendCredits': 'Versand-Guthaben',
  'app.freeSendBanner': 'Sie haben 1 kostenlosen E-Mail-Versand — nutzen Sie ihn, um Ihr Dokument zur Unterschrift zu senden. Jederzeit upgraden.',
  'app.creditEqualsSend': '1 Guthaben = 1 E-Mail-Versand',
  'app.topUpCredits': 'Guthaben aufladen',
  'app.emailSends': 'E-Mail-Versände',
  'app.signedAgreements': 'unterzeichnete Vereinbarungen',
  'app.usedAfterAllowance': '(nach monatlichem Kontingent)',
  'app.sendForSignature': 'Zur Signatur senden',
  'app.recipientsSection': 'Senden an',
  'app.fromNameOrg': 'Absender Name / Organisation',
  'app.fromNamePlaceholder': 'Ihr Name oder Organisation',
  'app.fromEmail': 'Absender-E-Mail',
  'app.fromEmailPlaceholder': 'Absender-E-Mail-Adresse',
  'app.recipientEmail': 'Empfänger-E-Mail',
  'app.recipientHint': 'Kommagetrennt, bis zu {{max}} Empfänger',
  'app.recipientPlaceholder': 'Empfänger-E-Mail-Adresse',
  'app.recipientTooltip': 'Beispiel: a@b.com, c@d.com, e@f.com',
  'app.previewPdf': 'PDF-Vorschau',
  'app.clearEverything': 'Alles löschen',
  'app.clearEverythingTitle': 'Dokument, Empfänger und Entwurf löschen',
  'app.copyLink': 'Link kopieren',
  'app.copyLinkSubscribersOnly': 'Link kopieren (nur für Abonnenten)',
  'app.generatingLink': 'Link wird erstellt…',
  'app.sendEmail': 'E-Mail senden',
  'app.agreementText': 'Vertragstext',
  'app.uploadPdfExtract': 'PDF hochladen zum Textextrakt',
  'app.fullPdfUpload': 'Vollständiger PDF-Upload',
  'app.agreementPlaceholder': 'Hier klicken und Vertragstext eingeben...',
  'app.attachments': 'Anhänge',
  'app.attachmentsHint': 'Bis zu 10 Dateien, max. 8 MB gesamt für den Versand.',
  'app.addAttachment': '+ Anhang hinzufügen',
  'app.signatureSection': 'Signaturbereich',
  'app.totalSignatures': 'Signaturen gesamt',
  'app.createNewField': 'Neues Feld erstellen',
  'app.addField': 'Feld hinzufügen',
  'app.layout': 'Layout',
  'app.editLayout': 'Layout bearbeiten',
  'app.addFieldTooltip': 'Eigenes Feld (Text, Datum, Checkbox oder Signatur) zum Signaturblock hinzufügen. Das Feld erscheint im Layout und kann unter Layout bearbeiten sortiert oder entfernt werden. Max. {{max}} eigene Felder.',
  'app.date': 'Datum',
  'app.datePlaceholder': 'jjjj/mm/tt',
  'app.termsConditions': 'Geschäftsbedingungen',
  'app.fullName': 'Vollständiger Name',
  'app.fullNamePlaceholder': 'Vollständigen Namen eingeben',
  'app.signature': 'Signatur',
  'app.clickToSign': 'Klicken zum Signieren',
  'app.termsAgree': 'Ich akzeptiere die Geschäftsbedingungen.',
  'app.phone': 'Telefon',
  'app.phonePlaceholder': 'Telefonnummer eingeben',
  'app.enterFieldPlaceholder': '{{label}} eingeben',
  'app.enterNumber': 'Zahl eingeben',
  'app.selectOption': 'Auswählen...',
  'app.noFields': 'Keine Felder',
  'app.newDocument': 'Neues Dokument',
  'app.templateLabel': 'Vorlage: {{name}}',
  'app.forSubscribersOnly': 'Nur für Abonnenten',
  'app.emailCredits': 'E-Mail-Guthaben',
  'app.creditHintDeliver': '1 Guthaben = 1 E-Mail-Versand — Senden klicken zum Zustellen',
  'app.skipAuthTesting': 'Auth überspringen (zum Testen)',
  'app.agreementRequired': 'Vertragstext oder PDF-Upload erforderlich.',
  'app.agreementOrPdfRequired': 'Vertragstext oder ein PDF-Dokument ist erforderlich.',
  'app.loadingPdf': 'PDF wird geladen…',
  'app.clearConfirmTitle': 'Alles löschen',
  'app.clearConfirmMessage': 'Alle Felder und Anhänge wirklich löschen?',
  'app.cancel': 'Abbrechen',
  'app.clear': 'Löschen',
  'app.clearConfirmButton': 'Ja, alles löschen',
  'footer.tagline': 'Sichere E-Signatur für moderne Nutzer.',
  'footer.product': 'Produkt',
  'footer.templates': 'Vorlagen',
  'footer.company': 'Unternehmen',
  'footer.contactSupport': 'Support',
  'footer.copyright': '© 2026 primedocumentsign. Alle Rechte vorbehalten.',
  'footer.terms': 'Nutzungsbedingungen',
  'footer.privacy': 'Datenschutz',
  'auth.logIn': 'Anmelden',
  'auth.loggingIn': 'Anmeldung…',
  'auth.getStarted': 'Loslegen',
  'auth.signUp': 'Registrieren',
  'auth.logInToManage': 'Anmelden zum Verwalten und Senden von Dokumenten.',
  'auth.startSending': 'Mit einem einfachen Abo Dokumente senden.',
  'auth.termsConfirmStart': 'Ich bestätige, dass ich die',
  'auth.termsConfirmEnd': ' gelesen habe und akzeptiere.',
  'auth.termsMustAccept': 'Bitte akzeptieren Sie die Nutzungsbedingungen, um ein Konto anzulegen.',
  'email.signSubject': 'Bitte unterzeichnen Sie diese Vereinbarung',
  'email.signTitle': 'Dokument zur Unterzeichnung',
  'email.signSubtitle': 'Sie wurden gebeten, ein Dokument zu unterzeichnen',
  'email.fromLabel': 'Von',
  'email.signBody': 'Klicken Sie auf die Schaltfläche unten, um das Dokument zu öffnen und Ihre Unterschrift hinzuzufügen. Jeder Empfänger kann diesen Link nutzen — kein Konto oder Abo nötig.',
  'email.signButton': 'Dokument unterzeichnen',
  'email.copyLink': 'Oder kopieren Sie diesen Link:',
  'email.ignoreNote': 'Wenn Sie diese E-Mail nicht erwartet haben, können Sie sie ignorieren.',
  'modal.editFieldLayout': 'Feldlayout bearbeiten',
  'modal.editFieldLayoutHint': 'Felder ziehen zum Sortieren oder Verschieben zwischen Spalten.',
  'modal.columns': 'Spalten',
  'modal.col': '{{n}} Sp.',
  'modal.addSpace': 'Abstand hinzufügen',
  'modal.addField': 'Feld hinzufügen',
  'modal.fields': 'Felder',
  'modal.leftColumn': 'Linke Spalte',
  'modal.rightColumn': 'Rechte Spalte',
  'modal.removeFromLayout': '{{name}} aus Layout entfernen?',
  'modal.space': 'Abstand',
  'modal.yesRemove': 'Ja, entfernen',
  'modal.keepIt': 'Behalten',
  'modal.emptySpace': 'Leerer Bereich',
  'modal.dropFieldsHere': 'Felder hier ablegen',
  'modal.removedFromLayout': 'Aus Layout entfernt — auf + klicken zum Wiederherstellen',
  'modal.saveLayout': 'Layout speichern',
  'modal.removeFromLayoutTitle': 'Aus Layout entfernen',
  'modal.restoreToLayout': 'Ins Layout wiederherstellen',
  'modal.editCustomField': 'Eigenes Feld bearbeiten',
  'modal.editCustomFieldHint': 'Bezeichnung, Typ oder Sichtbarkeit für Unterzeichner ändern.',
  'modal.addCustomField': 'Eigenes Feld hinzufügen',
  'modal.addCustomFieldHint': 'Neues Feld für das Signaturformular. Max. 10 eigene Felder.',
  'modal.fieldLabel': 'Feldbezeichnung',
  'modal.fieldLabelPlaceholder': 'z. B. Firmenname',
  'modal.fieldType': 'Feldtyp',
  'modal.displayContent': 'Anzeigeinhalt (nur Leseansicht für Empfänger, max. 100 Zeichen)',
  'modal.displayContentPlaceholder': 'z. B. Bitte prüfen Sie die Bedingungen unten',
  'modal.picklistOptions': 'Auswahllisten-Optionen (max. 10)',
  'modal.typeAndPressAdd': 'Eingeben und Hinzufügen drücken',
  'modal.add': 'Hinzufügen',
  'modal.addedToSignature': 'Zur Signatur hinzugefügt',
  'modal.addedToSignatureHint': 'Kästchen unten ankreuzen, um das neue Feld ins Signaturlayout aufzunehmen',
  'modal.signature1': 'Signatur 1',
  'modal.signature2': 'Signatur 2',
  'modal.close': 'Schließen',
  'modal.save': 'Speichern',
  'modal.fieldLabelRequired': 'Feldbezeichnung ist erforderlich',
  'modal.displayContentRequired': 'Anzeigeinhalt ist bei „Text anzeigen“ erforderlich',
  'modal.picklistOptionRequired': 'Mindestens eine Option hinzufügen',
  'modal.selectOneSignature': 'Mindestens eine Signatur auswählen',
  'modal.signingSectionExceed': 'Signaturbereich würde {{limit}} KB überschreiten. Bitte Inhalt entfernen.',
  'modal.link': 'Link',
  'modal.linkTitle': 'Linktitel',
  'modal.linkUrl': 'Link-URL',
  'modal.linkTextPlaceholder': 'Linktext',
  'modal.linkUrlPlaceholder': 'https://example.com',
  'modal.agreementSizeLimitReached': 'Maximale Vertragsgröße erreicht',
  'modal.characterLimitReached': 'Zeichenlimit erreicht',
  'modal.agreementSizeLimitMessage': 'Maximale Vertragsgröße ({{max}} KB) erreicht. Bitte Inhalt oder Bilder entfernen.',
  'modal.characterLimitMessage': 'Zeichenlimit ({{max}}) erreicht. Bitte Text kürzen.',
  'modal.signingSectionLimitReached': 'Signaturbereich-Limit erreicht',
  'modal.signingSectionLimitMessage': 'Maximale Größe des Signaturbereichs ({{limit}} KB) erreicht. Felder, Signaturen oder eigene Felder entfernen.',
  'modal.ok': 'OK',
  'modal.addYourSignature': 'Signatur hinzufügen',
  'modal.signatureHint': 'Maus oder Trackpad zum Signieren verwenden.',
  'modal.clear': 'Löschen',
  'modal.saveSignature': 'Signatur speichern',
  'modal.removeAttachment': 'Anhang entfernen',
  'modal.removeAttachmentConfirm': '"{{name}}" wirklich aus diesem Dokument entfernen?',
  'modal.yesRemoveLabel': 'Ja, entfernen',
  'modal.removeLogo': 'Logo entfernen',
  'modal.removeLogoConfirm': 'Logo wirklich aus diesem Dokument entfernen?',
  'modal.textDisplay': 'Text anzeigen',
  'modal.picklist': 'Auswahlliste',
  'modal.number': 'Zahl',
  'modal.time': 'Uhrzeit',
  'modal.editLabel': 'Bezeichnung bearbeiten',
  'modal.editField': 'Feld bearbeiten',
  'modal.text': 'Text',
  'modal.checkbox': 'Checkbox',
  'modal.date': 'Datum',
  'modal.signature': 'Signatur',
  'modal.typeHasDataHint': 'Typ kann nicht geändert werden, da das Feld bereits Daten enthält.',
  'modal.typeHasDataTitle': 'Typ nicht änderbar bei vorhandenen Daten',
  'modal.noKeepIt': 'Nein, behalten',
  'modal.yesDelete': 'Ja, löschen',
  'modal.deleteTemplate': 'Vorlage löschen',
  'modal.deleteTemplateConfirm': 'Vorlage "{{name}}" wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
  'modal.removeAttachmentFromMessage': '"{{name}}" aus Ihrer Nachricht entfernen?',
  'modal.readyToSend': 'Bereit zum Senden?',
  'modal.recipientsLabel': 'Empfänger:',
  'modal.readyToSendSubtitle': 'Haben Sie das Dokument geprüft und möchten es senden? Folgende Empfänger erhalten diese E-Mail:',
  'modal.readyToSendNote': 'Beim PDF-Download: Die Signatur kann abgeschnitten werden, wenn der Abstand nicht stimmt. Bitte vor dem Senden prüfen und anpassen.',
  'modal.no': 'Nein',
  'modal.yesSend': 'Ja, senden',
  'modal.accountAlreadyExists': 'Konto existiert bereits',
  'modal.accountAlreadyExistsMessage': 'Diese E-Mail ist bereits registriert. Anmelden oder mit anderer E-Mail registrieren?',
  'modal.useDifferentEmail': 'Andere E-Mail verwenden',
  'modal.logIn': 'Anmelden',
  'modal.logOut': 'Abmelden?',
  'modal.logOutSubtitle': 'Möchten Sie sich wirklich abmelden?',
  'modal.yesLogOut': 'Ja, abmelden',
  'lang.en': 'Englisch',
  'lang.es': 'Spanisch',
  'lang.pt': 'Portugiesisch',
  'lang.ja': 'Japanisch',
  'lang.zh': 'Chinesisch',
  'lang.hi': 'Hindi',
  'lang.fr': 'Französisch',
  'lang.it': 'Italienisch',
  'lang.de': 'Deutsch',
  'lang.ar': 'Arabisch',

  'templates.starter.nda.name': 'Vertraulichkeitsvereinbarung (NDA)',
  'templates.starter.nda.scopeTitle': 'Vertraulichkeitsvereinbarung',
  'templates.starter.freelance.name': 'Freelance-Dienstleistungsvertrag',
  'templates.starter.freelance.scopeTitle': 'Freelance-Dienstleistungsvertrag',
  'templates.starter.vehicle.name': 'Fahrzeugkaufvertrag',
  'templates.starter.vehicle.scopeTitle': 'Fahrzeugkaufvertrag',
  'templates.starter.rental.name': 'Wohnraummietvertrag',
  'templates.starter.rental.scopeTitle': 'Wohnraummietvertrag',
  'templates.starter.recruitment.name': 'Personalvermittlungsvertrag',
  'templates.starter.recruitment.scopeTitle': 'Personalvermittlungsvertrag',
  'templates.starter.loan.name': 'Darlehensvereinbarung',
  'templates.starter.loan.scopeTitle': 'Darlehensvereinbarung',
  'templates.starter.website.name': 'Website-Entwicklungsvertrag',
  'templates.starter.website.scopeTitle': 'Website-Entwicklungsvertrag',
  'templates.starter.roommate.name': 'Mitbewohnervereinbarung',
  'templates.starter.roommate.scopeTitle': 'Mitbewohnervereinbarung',
  'templates.starter.photography.name': 'Fotografie-Dienstleistungsvertrag',
  'templates.starter.photography.scopeTitle': 'Fotografie-Dienstleistungsvertrag',
  'templates.starter.shortterm-rental.name': 'Kurzzeitmietvertrag',
  'templates.starter.shortterm-rental.scopeTitle': 'Kurzzeitmietvertrag',
  'templates.starter.equipment-rental.name': 'Gerätemietvertrag',
  'templates.starter.equipment-rental.scopeTitle': 'Gerätemietvertrag',
  'templates.starter.independent-contractor.name': 'Vertrag für freie Mitarbeiter',
  'templates.starter.independent-contractor.scopeTitle': 'Vertrag für freie Mitarbeiter',
}
